export {
  STRIPE_PUBLISHABLE_KEY,
  CHARGEBEE_PUBLISHABLE_KEY,
  INTERCOM_APP_ID,
  DATAAPI_ROOT,
  NEWSAPI_ROOT,
  CALENDARSAPI_ROOT,
  BASE_URL,
} from './env.client';

import { BASE_URL } from './env.client';

// ---------------------------------------------------------------------------
// Secret helpers — read from process.env, never hardcoded.
// Set these in GitLab CI/CD Variables (masked) or in .env.local for local dev.
// See .env.local.example for the full list.
// ---------------------------------------------------------------------------
const e = process.env;

export const SESSION_ENV = {
  'benzinga-advanced-news': {
    CFClientID: e.BZ_CF_CLIENT_ID ?? '',
    CFClientSecret: e.BZ_CF_CLIENT_SECRET ?? '',
    contentKey: e.BZ_ADVANCED_NEWS_CONTENT_KEY ?? '',
    contentUrl: 'https://content-internal.benzinga.com/content/',
    editorialToolsUrl: 'https://editorial-tools.benzinga.com/api/v2/',
    socketUrl: 'wss://api-next.benzinga.com/api/v3/news/advanced/ws',
    url: 'https://www.benzinga.com/',
  },
  'benzinga-article': {
    editorialPreviewKey: e.BZ_ARTICLE_EDITORIAL_PREVIEW_KEY ?? '',
    internalContentKey: e.BZ_ARTICLE_INTERNAL_CONTENT_KEY ?? '',
    key: e.BZ_ARTICLE_KEY ?? '',
    recommendedArticlesUrl: `${BASE_URL}/api-next/`,
    url: 'https://www.benzinga.com/',
    wnstnUrl: 'https://editorial-tools.benzinga.com/api/v2/wnstn/',
  },
  'benzinga-authentication': {
    googleClientId: '325438794491-bg460k8jbhbqavvn6ve5ilc1e34s8892.apps.googleusercontent.com',
    url: 'https://accounts.benzinga.com',
  },
  'benzinga-autocomplete': {
    fundsUrl: 'https://www.benzinga.com',
    symbolsKey: e.BZ_DATA_API_KEY ?? '',
    symbolsUrl: `${BASE_URL}/api-next/`,
  },
  'benzinga-basic-news': {
    chartBeatUrl: `${BASE_URL}/`,
    editorialToolsUrl: 'https://editorial-tools.benzinga.com/api/v2/',
    nodeContentUrl: `${BASE_URL}/api-next/`,
    simplyQueryUrl: `${BASE_URL}/`,
  },
  'benzinga-calendar': {
    dataUrl: `${BASE_URL}/api-next/`,
    eventsToken: e.BZ_CALENDAR_EVENTS_TOKEN ?? '',
    secToken: e.BZ_CALENDAR_SEC_TOKEN ?? '',
    token: e.BZ_CALENDAR_TOKEN ?? '',
    url: 'https://www.benzinga.com/',
  },
  'benzinga-calendar-dividends': {
    token: e.BZ_CALENDAR_TOKEN ?? '',
    url: `${BASE_URL}/api-next/`,
  },
  'benzinga-calendar-economics': {
    token: e.BZ_CALENDAR_TOKEN ?? '',
    url: 'https://api.benzinga.com/api/v2.1/calendar/economics',
  },
  'benzinga-calendar-option-activity': {
    token: e.BZ_CALENDAR_TOKEN ?? '',
    url: `${BASE_URL}/api-next/`,
  },
  'benzinga-chart': {
    barsKey: e.BZ_CHART_BARS_KEY ?? '',
    barsUrl: `${BASE_URL}/api-next/`,
    cryptoUrl: 'https://www.benzinga.com/',
    key: e.BZ_CHART_KEY ?? '',
    url: `${BASE_URL}/api-next/`,
  },
  'benzinga-chat': {
    streamKey: e.BZ_CHAT_STREAM_KEY ?? '',
    url: 'https://accounts.benzinga.com/',
  },
  'benzinga-comments': {
    url: `${BASE_URL}/`,
  },
  'benzinga-content': {
    internalMoneyLayoutUrl: 'http://money-layout.core-prod/lavapress/api/',
    internalMoneyUrl: 'http://benzinga-gen-wordpress.core-prod/lavapress/api/',
    moneyJobsUrl: 'https://money-jobs.benzinga.com/api/',
    url: 'https://www.benzinga.com/lavapress/api/',
  },
  'benzinga-edge': {
    url: `${BASE_URL}/`,
  },
  'benzinga-forex-quotes': {
    url: `${BASE_URL}/`,
  },
  'benzinga-internal-news': {
    url: 'https://www.benzinga.com/',
  },
  'benzinga-investors': {
    key: '',
    token: '',
    url: `${BASE_URL}/api-next/`,
  },
  'benzinga-layout': {
    url: 'https://accounts.benzinga.com',
  },
  'benzinga-licensing': {
    url: 'https://api.benzinga.com/',
  },
  'benzinga-livestream': {
    url: 'https://www.benzinga.com/lavapress/api/',
  },
  'benzinga-movers': {
    url: `${BASE_URL}/api-next/`,
  },
  'benzinga-notes': {
    url: 'https://accounts.benzinga.com/',
  },
  'benzinga-option-chain': {
    apiKey: e.BZ_ARTICLE_KEY ?? '',
    url: `${BASE_URL}/api-next/`,
  },
  'benzinga-permissions': {
    url: 'https://accounts.benzinga.com/',
  },
  'benzinga-price-alerts': {
    url: 'https://data-api-pro.benzinga.com/rest/v1/',
  },
  'benzinga-quotes': {
    bullSayBearSayToken: e.BZ_QUOTES_BULL_SAY_BEAR_SAY_TOKEN ?? '',
    bullSayBearSayUrl: `${BASE_URL}/api-next/`,
    delayedQuoteKey: e.BZ_QUOTES_DELAYED_QUOTE_KEY ?? '',
    delayedQuoteUrl: `${BASE_URL}/api-next/`,
    logosKey: e.BZ_QUOTES_LOGOS_KEY ?? '',
    logosUrl: `${BASE_URL}/api-next/`,
    scheduleKey: e.BZ_QUOTES_SCHEDULE_KEY ?? '',
    scheduleUrl: `${BASE_URL}/api-next/`,
    shortInterestKey: e.BZ_QUOTES_SHORT_INTEREST_KEY ?? '',
    shortInterestUrl: `${BASE_URL}/api-next/`,
    socketUrl: 'wss://pro-quote-v2.benzinga.com/quote/',
    symbolsKey: e.BZ_QUOTES_SYMBOLS_KEY ?? '',
    symbolsUrl: `${BASE_URL}/api-next/`,
    tickersKey: e.BZ_QUOTES_TICKERS_KEY ?? '',
    tickersUrl: `${BASE_URL}/api-next/`,
  },
  'benzinga-quotes-v3': {
    socketUrl: 'wss://data-api-next.benzinga.com/api/v3/quotes/ws?quote_access=polygon_realtime,finage_crypto',
  },
  'benzinga-scanner': {
    key: e.BZ_SCANNER_KEY ?? '',
    equityUrl: `${BASE_URL}/api-next/`,
    cryptoUrl: `${BASE_URL}/api-next/`,
  },
  'benzinga-securities': {
    key: e.BZ_DATA_API_KEY ?? '',
    url: `${BASE_URL}/api-next/securities/`,
  },
  'benzinga-shop': {
    url: 'https://accounts.benzinga.com/api/v1/',
  },
  'benzinga-signals': {
    restfulUrl: 'https://signals.benzinga.io/signals/api/',
    socketUrl: 'wss://signals.benzinga.io/signals/ws',
  },
  'benzinga-subscriptions': {
    url: 'https://accounts.benzinga.com/',
  },
  'benzinga-trending-topics': {
    url: `${BASE_URL}/api-next/`,
  },
  'benzinga-videos': {
    toolsUrl: 'https://www.benzinga.com/lavapress/api/',
    url: 'https://www.benzinga.com/',
  },
  'benzinga-watchlist': {
    fastLinkConfigName: 'Aggregation',
    fastLinkUrl: 'https://fl4.prod.yodlee.com/authenticate/USDevexProd3-130/fastlink?channelAppName=usdevexprod3',
    legacyUrl: 'https://www.benzinga.com/',
    url: 'https://api.benzinga.com/',
  },
  'benzinga-search': {
    url: 'https://embedded-search.prod.api.benzinga.dev/v1/',
    CFAccessClientId: e.BZ_SEARCH_CF_ACCESS_CLIENT_ID ?? '',
    CFAccessClientSecret: e.BZ_SEARCH_CF_ACCESS_CLIENT_SECRET ?? '',
  },
  'benzinga-user': {
    segmentUrl: `${BASE_URL}/`,
  },
};

export const SESSION_STAGING_ENV = {
  'benzinga-advanced-news': {
    contentKey: e.BZ_ADVANCED_NEWS_CONTENT_KEY ?? '',
    contentUrl: 'https://content-internal.benzinga.com/content/',
    editorialToolsUrl: 'https://editorial-tools.zingbot.bz/api/v2/',
    socketUrl: 'wss://api-next.benzinga.com/api/v3/news/advanced/ws',
    url: 'https://www.benzinga.com/',
  },
  'benzinga-article': {
    analyticsUrl: 'https://bz.zingbot.bz/',
    editorialPreviewKey: e.BZ_ARTICLE_EDITORIAL_PREVIEW_KEY_STAGING ?? '',
    internalContentKey: e.BZ_ARTICLE_INTERNAL_CONTENT_KEY ?? '',
    key: e.BZ_ARTICLE_KEY ?? '',
    recommendedArticlesUrl: `${BASE_URL}/api-next/`,
    url: 'https://www.benzinga.com/',
    wnstnUrl: 'https://editorial-tools.zingbot.bz/api/v2/wnstn/',
  },
  'benzinga-authentication': {
    googleClientId: '1041762027085-g29rukffvi2pdjrg9800am4a3591jfi5.apps.googleusercontent.com',
    url: 'https://accounts.zingbot.bz',
  },
  'benzinga-autocomplete': {
    ...SESSION_ENV['benzinga-autocomplete'],
  },
  'benzinga-basic-news': {
    ...SESSION_ENV['benzinga-basic-news'],
    editorialToolsUrl: 'https://editorial-tools.zingbot.bz/api/v2/',
  },
  'benzinga-calendar': {
    ...SESSION_ENV['benzinga-calendar'],
  },
  'benzinga-calendar-dividends': {
    ...SESSION_ENV['benzinga-calendar-dividends'],
  },
  'benzinga-calendar-economics': {
    ...SESSION_ENV['benzinga-calendar-economics'],
  },
  'benzinga-calendar-option-activity': {
    ...SESSION_ENV['benzinga-calendar-option-activity'],
  },
  'benzinga-chart': {
    ...SESSION_ENV['benzinga-chart'],
  },
  'benzinga-chat': {
    ...SESSION_ENV['benzinga-chat'],
  },
  'benzinga-content': {
    editorialToolsUrl: 'https://editorial-tools.zingbot.bz/api/v2/',
    internalMoneyLayoutUrl: 'https://www.benzinga.com/lavapress/api/',
    internalMoneyUrl: 'https://www.benzinga.com/lavapress/api/',
    moneyJobsUrl: 'https://money-jobs.benzinga.com/api/',
    url: 'https://www.benzinga.com/lavapress/api/',
  },
  'benzinga-edge': {
    ...SESSION_ENV['benzinga-edge'],
  },
  'benzinga-comments': {
    ...SESSION_ENV['benzinga-comments'],
  },
  'benzinga-forex-quotes': {
    ...SESSION_ENV['benzinga-forex-quotes'],
  },
  'benzinga-internal-news': {
    ...SESSION_ENV['benzinga-internal-news'],
  },
  'benzinga-investors': {
    ...SESSION_ENV['benzinga-investors'],
  },
  'benzinga-layout': {
    ...SESSION_ENV['benzinga-layout'],
  },
  'benzinga-licensing': {
    url: 'https://api.zingbot.bz/',
  },
  'benzinga-livestream': {
    ...SESSION_ENV['benzinga-livestream'],
  },
  'benzinga-movers': {
    ...SESSION_ENV['benzinga-movers'],
  },
  'benzinga-option-chain': {
    ...SESSION_ENV['benzinga-option-chain'],
  },
  'benzinga-notes': {
    ...SESSION_ENV['benzinga-notes'],
  },
  'benzinga-permissions': {
    ...SESSION_ENV['benzinga-permissions'],
  },
  'benzinga-price-alerts': {
    url: 'https://data-api-pro.zingbot.bz/rest/v1/',
  },
  'benzinga-quotes': {
    ...SESSION_ENV['benzinga-quotes'],
  },
  'benzinga-quotes-v3': {
    ...SESSION_ENV['benzinga-quotes-v3'],
  },
  'benzinga-scanner': {
    ...SESSION_ENV['benzinga-scanner'],
  },
  'benzinga-securities': {
    ...SESSION_ENV['benzinga-securities'],
  },
  'benzinga-shop': {
    ...SESSION_ENV['benzinga-shop'],
  },
  'benzinga-signals': {
    ...SESSION_ENV['benzinga-signals'],
  },
  'benzinga-subscriptions': {
    ...SESSION_ENV['benzinga-subscriptions'],
  },
  'benzinga-trending-topics': {
    ...SESSION_ENV['benzinga-trending-topics'],
  },
  'benzinga-videos': {
    ...SESSION_ENV['benzinga-videos'],
  },
  'benzinga-watchlist': {
    legacyUrl: 'https://www.benzinga.com/',
    url: 'https://api.benzinga.com/',
  },
  'benzinga-search': {
    url: 'https://embedded-search.staging.api.benzinga.dev/v1/',
    CFAccessClientId: e.BZ_SEARCH_CF_ACCESS_CLIENT_ID_STAGING ?? '',
    CFAccessClientSecret: e.BZ_SEARCH_CF_ACCESS_CLIENT_SECRET_STAGING ?? '',
  },
  'benzinga-user': {
    ...SESSION_ENV['benzinga-user'],
  },
};

export const SESSION_DEV_ENV = {
  'benzinga-advanced-news': {
    ...SESSION_ENV['benzinga-advanced-news'],
    url: `${BASE_URL}/`,
  },
  'benzinga-alts': {},
  'benzinga-article': {
    analyticsUrl: BASE_URL,
    commentsUrl: `${BASE_URL}/`,
    editorialPreviewKey: e.BZ_ARTICLE_EDITORIAL_PREVIEW_KEY_STAGING ?? '',
    externalUrl: BASE_URL,
    internalContentKey: e.BZ_ARTICLE_INTERNAL_CONTENT_KEY ?? '',
    key: e.BZ_ARTICLE_KEY ?? '',
    recommendedArticlesUrl: `${BASE_URL}/api-next/`,
    relevantUrl: BASE_URL,
    url: 'https://www.benzinga.com/',
    wnstnUrl: 'https://editorial-tools.benzinga.com/api/wnstn/',
  },
  'benzinga-authentication': {
    googleClientId: '1041762027085-g29rukffvi2pdjrg9800am4a3591jfi5.apps.googleusercontent.com',
    url: 'https://accounts.benzinga.com',
  },
  'benzinga-autocomplete': {
    ...SESSION_ENV['benzinga-autocomplete'],
  },
  'benzinga-basic-news': {
    ...SESSION_ENV['benzinga-basic-news'],
    editorialToolsUrl: 'https://editorial-tools.zingbot.bz/api/v2/',
  },
  'benzinga-calendar': {
    ...SESSION_ENV['benzinga-calendar'],
  },
  'benzinga-calendar-dividends': {
    ...SESSION_ENV['benzinga-calendar-dividends'],
  },
  'benzinga-calendar-economics': {
    ...SESSION_ENV['benzinga-calendar-economics'],
  },
  'benzinga-calendar-option-activity': {
    ...SESSION_ENV['benzinga-calendar-option-activity'],
  },
  'benzinga-chart': {
    ...SESSION_ENV['benzinga-chart'],
    cryptoUrl: `${BASE_URL}/`,
  },
  'benzinga-chat': {
    ...SESSION_ENV['benzinga-chat'],
  },
  'benzinga-comments': {
    ...SESSION_ENV['benzinga-comments'],
  },
  'benzinga-commodities': {
    url: 'https://www.benzinga.com/lavapress/api/',
  },
  'benzinga-predictions': {
    url: 'https://www.benzinga.com/lavapress/api/',
  },
  'benzinga-content': {
    editorialToolsUrl: 'https://editorial-tools.zingbot.bz/api/v2/',
    internalMoneyLayoutUrl: 'https://www.benzinga.com/lavapress/api/',
    internalMoneyUrl: 'https://www.benzinga.com/lavapress/api/',
    moneyJobsUrl: 'https://money-jobs.benzinga.com/api/',
    url: 'https://www.benzinga.com/lavapress/api/',
  },
  'benzinga-edge': {
    ...SESSION_ENV['benzinga-edge'],
  },
  'benzinga-forex-quotes': {
    url: `${BASE_URL}/`,
  },
  'benzinga-internal-news': {
    url: `${BASE_URL}/`,
  },
  'benzinga-investors': {
    ...SESSION_ENV['benzinga-investors'],
  },
  'benzinga-layout': {
    url: 'https://accounts.benzinga.com',
  },
  'benzinga-licensing': {
    url: 'https://api.zingbot.bz/',
  },
  'benzinga-livestream': {
    ...SESSION_ENV['benzinga-livestream'],
  },
  'benzinga-movers': {
    url: `${BASE_URL}/api-next/`,
  },
  'benzinga-option-chain': {
    ...SESSION_ENV['benzinga-option-chain'],
    url: `${BASE_URL}/api-next/`,
  },
  'benzinga-notes': {
    ...SESSION_ENV['benzinga-notes'],
  },
  'benzinga-permissions': {
    ...SESSION_ENV['benzinga-permissions'],
  },
  'benzinga-price-alerts': {
    ...SESSION_ENV['benzinga-price-alerts'],
  },
  'benzinga-quotes': {
    ...SESSION_ENV['benzinga-quotes'],
    analysisUrl: `${BASE_URL}/`,
    peerQuotesUrl: `${BASE_URL}/api-next/`,
  },
  'benzinga-quotes-v3': {
    ...SESSION_ENV['benzinga-quotes-v3'],
  },
  'benzinga-scanner': {
    ...SESSION_ENV['benzinga-scanner'],
  },
  'benzinga-securities': {
    ...SESSION_ENV['benzinga-securities'],
  },
  'benzinga-shop': {
    ...SESSION_ENV['benzinga-shop'],
  },
  'benzinga-signals': {
    ...SESSION_ENV['benzinga-signals'],
  },
  'benzinga-subscriptions': {
    ...SESSION_ENV['benzinga-subscriptions'],
  },
  'benzinga-trending-topics': {
    ...SESSION_ENV['benzinga-trending-topics'],
  },
  'benzinga-videos': {
    toolsUrl: 'https://www.benzinga.com/lavapress/api/',
    url: `${BASE_URL}/`,
  },
  'benzinga-watchlist': {
    legacyUrl: 'https://www.benzinga.com/',
    url: 'https://api.benzinga.com/',
  },
  'benzinga-user': {
    ...SESSION_ENV['benzinga-user'],
  },
  'benzinga-search': {
    url: 'https://embedded-search.prod.api.benzinga.dev/v1/',
    CFAccessClientId: e.BZ_SEARCH_CF_ACCESS_CLIENT_ID ?? '',
    CFAccessClientSecret: e.BZ_SEARCH_CF_ACCESS_CLIENT_SECRET ?? '',
  },
};

export const SESSION_SANDBOX_ENV = {
  ...SESSION_STAGING_ENV,
  'benzinga-article': {
    ...SESSION_STAGING_ENV['benzinga-article'],
    url: 'https://www.benzinga.com/',
  },
  'benzinga-authentication': {
    ...SESSION_STAGING_ENV['benzinga-authentication'],
    url: 'https://accounts.benzinga.com',
  },
  'benzinga-price-alerts': {
    ...SESSION_ENV['benzinga-price-alerts'],
  },
  'benzinga-securities': {
    ...SESSION_STAGING_ENV['benzinga-securities'],
    url: `${BASE_URL}/api-next/securities/`,
  },
};

export const SESSION_SERVER_ENV = {
  ...SESSION_ENV,
  'benzinga-advanced-news': {
    ...SESSION_ENV['benzinga-advanced-news'],
    internalContentUrl: 'http://content-server-next.pro-backend',
  },
  'benzinga-article': {
    ...SESSION_ENV['benzinga-article'],
    recommendedArticlesCFAccessClientId: e.BZ_CF_CLIENT_ID ?? '',
    recommendedArticlesCFAccessClientSecret: e.BZ_CF_CLIENT_SECRET ?? '',
    recommendedArticlesUrl: 'https://dot-com-content-recommendation.prod.api.benzinga.dev/',
  },
  'benzinga-autocomplete': {
    ...SESSION_ENV['benzinga-autocomplete'],
    symbolsUrl: 'http://autocomplete-api-standard.core-prod/rest/',
  },
  'benzinga-calendar': {
    ...SESSION_ENV['benzinga-calendar'],
    dataUrl: 'http://calendar-api.backend-licensing/api/',
    secDataUrl: 'https://api.benzinga.com/api/',
  },
  'benzinga-calendar-dividends': {
    ...SESSION_ENV['benzinga-calendar-dividends'],
    url: 'http://calendar-api.backend-licensing/api/',
  },
  'benzinga-calendar-economics': {
    ...SESSION_ENV['benzinga-calendar-economics'],
    url: 'http://calendar-api.backend-licensing/api/v2.1/calendar/economics',
  },
  'benzinga-calendar-option-activity': {
    ...SESSION_ENV['benzinga-calendar-option-activity'],
    url: 'http://calendar-api.backend-licensing/api/',
  },
  'benzinga-chart': {
    ...SESSION_ENV['benzinga-chart'],
    barsUrl: 'https://api.benzinga.com/api/',
    url: 'http://chart-api-next.core-prod/rest/',
  },
  'benzinga-movers': {
    ...SESSION_ENV['benzinga-movers'],
    key: e.BZ_MOVERS_KEY ?? '',
    url: 'https://api.benzinga.com/api/v1/market/',
  },
  'benzinga-investors': {
    ...SESSION_ENV['benzinga-investors'],
    key: e.BZ_SCANNER_KEY ?? '',
    token: e.BZ_INVESTORS_API_TOKEN ?? '',
    url: 'https://data-api-pro.benzinga.com/',
  },
  'benzinga-option-chain': {
    ...SESSION_ENV['benzinga-option-chain'],
    url: 'http://option-chain-api.core-prod/',
  },
  'benzinga-quotes': {
    ...SESSION_ENV['benzinga-quotes'],
    bullSayBearSayToken: e.BZ_QUOTES_BULL_SAY_BEAR_SAY_TOKEN ?? '',
    bullSayBearSayUrl: 'http://calendar-api.backend-licensing/',
    delayedQuoteUrl: 'http://quote2-api-delayed.core-prod/rest/',
    logosUrl: 'http://logo-api-v2.backend-licensing/api/',
    scheduleUrl: 'http://data-api-standard.core-prod/rest/',
    shortInterestKey: e.BZ_QUOTES_SHORT_INTEREST_KEY ?? '',
    shortInterestUrl: 'http://short-interest-api.core-prod/',
    symbolsUrl: 'http://data-api-standard.core-prod/rest/',
    tickersUrl: 'http://data-api-standard.core-prod/rest/',
  },
  'benzinga-basic-news': {
    ...SESSION_ENV['benzinga-basic-news'],
    nodeContentUrl: 'https://api.benzinga.com/',
  },
  'benzinga-securities': {
    ...SESSION_ENV['benzinga-securities'],
    key: '',
    peersKey: e.BZ_MOVERS_KEY ?? '',
    url: 'http://morningstar-api.core-prod/',
  },
  'benzinga-stock-reports': {
    url: 'http://automated-stock-reports.datascience/api/',
  },
  'benzinga-scanner': {
    ...SESSION_ENV['benzinga-scanner'],
    equityUrl: 'http://scanner-http-server-v2.core-prod/rest/v2/scanner/us/equity/scan',
    cryptoUrl: 'https://data-api-pro.benzinga.com/rest/v2/scanner/crypto/scan',
  },
  'benzinga-search': {
    ...SESSION_ENV['benzinga-search'],
    url: 'http://embedded-search.datascience/v1/',
    CFAccessClientId: e.BZ_SEARCH_CF_ACCESS_CLIENT_ID ?? '',
    CFAccessClientSecret: e.BZ_SEARCH_CF_ACCESS_CLIENT_SECRET ?? '',
  },
  'benzinga-trending-topics': {
    ...SESSION_ENV['benzinga-trending-topics'],
    url: 'https://editorial-tools.benzinga.com/api/',
  },
};

export const SESSION_SERVER_STAGING_ENV = {
  ...SESSION_STAGING_ENV,
  'benzinga-advanced-news': {
    ...SESSION_STAGING_ENV['benzinga-advanced-news'],
    // internalContentUrl: 'https://api-next.benzinga.com',
    internalContentUrl: 'https://cloudflared-api.benzinga.com',
  },
  'benzinga-article': {
    ...SESSION_STAGING_ENV['benzinga-article'],
    recommendedArticlesCFAccessClientId: e.BZ_ARTICLE_CF_ACCESS_CLIENT_ID_STAGING ?? '',
    recommendedArticlesCFAccessClientSecret: e.BZ_ARTICLE_CF_ACCESS_CLIENT_SECRET_STAGING ?? '',
    recommendedArticlesUrl: 'https://dot-com-content-recommendation.staging.api.benzinga.dev/',
  },
  'benzinga-autocomplete': {
    ...SESSION_STAGING_ENV['benzinga-autocomplete'],
    symbolsUrl: 'https://data-api-next.benzinga.com/rest/',
  },
  'benzinga-basic-news': {
    ...SESSION_STAGING_ENV['benzinga-basic-news'],
    nodeContentUrl: 'https://api.benzinga.com/',
  },
  'benzinga-calendar': {
    ...SESSION_STAGING_ENV['benzinga-calendar'],
    dataUrl: 'https://api.benzinga.com/api/',
  },
  'benzinga-calendar-dividends': {
    ...SESSION_STAGING_ENV['benzinga-calendar-dividends'],
    url: 'https://api.benzinga.com/api/',
  },
  'benzinga-calendar-economics': {
    ...SESSION_STAGING_ENV['benzinga-calendar-economics'],
    url: 'https://api.benzinga.com/api/v2.1/calendar/economics',
  },
  'benzinga-calendar-option-activity': {
    ...SESSION_STAGING_ENV['benzinga-calendar-option-activity'],
    url: 'https://api.benzinga.com/api/',
  },
  'benzinga-chart': {
    ...SESSION_STAGING_ENV['benzinga-chart'],
    barsUrl: 'https://api.benzinga.com/api/',
    url: 'http://chart-api-next.core-staging/rest/',
  },
  'benzinga-investors': {
    ...SESSION_STAGING_ENV['benzinga-investors'],
    key: e.BZ_SCANNER_KEY ?? '',
    token: e.BZ_INVESTORS_API_TOKEN ?? '',
    url: 'https://data-api-pro.benzinga.com/',
  },
  'benzinga-movers': {
    ...SESSION_STAGING_ENV['benzinga-movers'],
    key: e.BZ_MOVERS_KEY ?? '',
    url: 'https://api.benzinga.com/api/v1/market/',
  },
  'benzinga-option-chain': {
    ...SESSION_STAGING_ENV['benzinga-option-chain'],
    url: 'https://data-api.benzinga.com/',
  },
  'benzinga-securities': {
    ...SESSION_STAGING_ENV['benzinga-securities'],
    peersKey: e.BZ_MOVERS_KEY ?? '',
    url: 'https://data-api-next.benzinga.com/rest/',
  },
  'benzinga-quotes': {
    ...SESSION_STAGING_ENV['benzinga-quotes'],
    bullSayBearSayUrl: 'https://api.benzinga.com/',
    // delayedQuoteUrl: 'http://quote2-api-delayed.core-staging/rest/',
    delayedQuoteUrl: 'https://data-api-next.benzinga.com/rest/',
    logosUrl: 'http://api.zingbot.bz/api/',
    scheduleUrl: 'http://data-api-standard.core-staging/rest/',
    shortInterestUrl: 'https://data-api.benzinga.com/',
    symbolsUrl: 'http://data-api-standard.core-staging/rest/',
    tickersUrl: 'https://data-api-next.benzinga.com/rest/',
    // tickersUrl: 'http://data-api-standard.core-staging/rest/',
  },
  'benzinga-stock-reports': {
    url: 'https://api.benzinga.com/api/',
  },
  'benzinga-scanner': {
    ...SESSION_STAGING_ENV['benzinga-scanner'],
    equityUrl: 'http://scanner-http-server-v2.core-staging/rest/v2/scanner/us/equity/scan',
    cryptoUrl: 'https://data-api-pro.benzinga.com/rest/v2/scanner/crypto/scan',
  },
  'benzinga-trending-topics': {
    ...SESSION_STAGING_ENV['benzinga-trending-topics'],
    url: 'https://editorial-tools.benzinga.com/api/',
  },
};

export const SESSION_SERVER_SANDBOX_ENV = {
  ...SESSION_SERVER_STAGING_ENV,
  'benzinga-advanced-news': {
    ...SESSION_ENV['benzinga-advanced-news'],
    internalContentUrl: 'https://cloudflared-api.benzinga.com',
  },
  'benzinga-authentication': {
    ...SESSION_SERVER_STAGING_ENV['benzinga-authentication'],
    url: 'https://accounts.benzinga.com',
  },
  'benzinga-price-alerts': {
    url: 'https://data-api-pro.benzinga.com/rest/v1/',
  },
  'benzinga-article': {
    ...SESSION_SERVER_STAGING_ENV['benzinga-article'],
    wnstnUrl: 'https://editorial-tools.benzinga.com/api/wnstn/',
  },
  'benzinga-calendar': {
    ...SESSION_SERVER_STAGING_ENV['benzinga-calendar'],
    dataUrl: 'https://api.benzinga.com/api/',
  },
  'benzinga-chart': {
    ...SESSION_ENV['benzinga-chart'],
    barsUrl: 'https://api.benzinga.com/api/',
    url: 'https://data-api-next.benzinga.com/rest/',
  },
  'benzinga-quotes': {
    ...SESSION_SERVER_STAGING_ENV['benzinga-quotes'],
    bullSayBearSayUrl: 'https://api.benzinga.com/',
    delayedQuoteUrl: 'https://data-api-next.benzinga.com/rest/',
    logosUrl: 'https://api.benzinga.com/api/',
    scheduleUrl: 'https://data-api-next.benzinga.com/rest/',
    shortInterestUrl: 'https://data-api.benzinga.com/',
    symbolsUrl: 'https://data-api-pro.benzinga.com/rest/',
    tickersUrl: 'https://data-api-next.benzinga.com/rest/',
  },
  'benzinga-stock-reports': {
    ...SESSION_SERVER_STAGING_ENV['benzinga-stock-reports'],
  },
  'benzinga-scanner': {
    ...SESSION_SERVER_STAGING_ENV['benzinga-scanner'],
    equityUrl: 'https://data-api-pro.benzinga.com/rest/v2/scanner/us/equity/scan',
    cryptoUrl: 'https://data-api-pro.benzinga.com/rest/v2/scanner/crypto/scan',
  },
};

export const SESSION_SERVER_DEV_ENV = {
  ...SESSION_DEV_ENV,
  'benzinga-advanced-news': {
    ...SESSION_ENV['benzinga-advanced-news'],
    internalContentUrl: 'https://cloudflared-api.benzinga.com',
  },
  'benzinga-article': {
    ...SESSION_DEV_ENV['benzinga-article'],
    externalUrl: 'https://www.benzinga.com/',
    recommendedArticlesCFAccessClientId: e.BZ_ARTICLE_CF_ACCESS_CLIENT_ID_STAGING ?? '',
    recommendedArticlesCFAccessClientSecret: e.BZ_ARTICLE_CF_ACCESS_CLIENT_SECRET_STAGING ?? '',
    recommendedArticlesUrl: 'https://dot-com-content-recommendation.staging.api.benzinga.dev/',
  },
  'benzinga-autocomplete': {
    ...SESSION_DEV_ENV['benzinga-autocomplete'],
    symbolsUrl: 'https://data-api-next.benzinga.com/rest/',
  },
  'benzinga-calendar': {
    ...SESSION_DEV_ENV['benzinga-calendar'],
    dataUrl: 'https://api.benzinga.com/api/',
  },
  'benzinga-calendar-dividends': {
    ...SESSION_DEV_ENV['benzinga-calendar-dividends'],
    url: 'https://api.benzinga.com/api/',
  },
  'benzinga-calendar-economics': {
    ...SESSION_DEV_ENV['benzinga-calendar-economics'],
    url: 'https://api.benzinga.com/api/v2.1/calendar/economics',
  },
  'benzinga-calendar-option-activity': {
    ...SESSION_DEV_ENV['benzinga-calendar-option-activity'],
    url: 'https://api.benzinga.com/api/',
  },
  'benzinga-movers': {
    ...SESSION_DEV_ENV['benzinga-movers'],
    key: e.BZ_MOVERS_KEY ?? '',
    url: 'https://api.benzinga.com/api/v1/market/',
  },
  'benzinga-basic-news': {
    ...SESSION_DEV_ENV['benzinga-basic-news'],
    nodeContentUrl: 'https://api.benzinga.com/',
  },
  'benzinga-investors': {
    ...SESSION_DEV_ENV['benzinga-investors'],
    key: e.BZ_SCANNER_KEY ?? '',
    token: e.BZ_INVESTORS_API_TOKEN ?? '',
    url: 'https://data-api-pro.benzinga.com/',
  },
  'benzinga-option-chain': {
    ...SESSION_ENV['benzinga-option-chain'],
    url: 'https://data-api-next.benzinga.com/',
  },
  'benzinga-price-alerts': {
    url: 'https://data-api-pro.benzinga.com/rest/v1/',
  },
  'benzinga-chart': {
    ...SESSION_DEV_ENV['benzinga-chart'],
    barsUrl: 'https://api.benzinga.com/api/',
    url: 'https://data-api-next.benzinga.com/rest/',
  },
  'benzinga-securities': {
    ...SESSION_DEV_ENV['benzinga-securities'],
    peersKey: e.BZ_MOVERS_KEY ?? '',
    url: 'https://data-api-next.benzinga.com/rest/',
  },
  'benzinga-quotes': {
    ...SESSION_DEV_ENV['benzinga-quotes'],
    bullSayBearSayUrl: 'https://api.benzinga.com/',
    delayedQuoteUrl: 'https://data-api-next.benzinga.com/rest/',
    logosUrl: 'https://api.benzinga.com/api/',
    scheduleUrl: 'https://data-api-next.benzinga.com/rest/',
    shortInterestUrl: 'https://data-api.benzinga.com/',
    symbolsUrl: 'https://data-api-next.benzinga.com/rest/',
    tickersUrl: 'https://data-api-next.benzinga.com/rest/',
  },
  'benzinga-stock-reports': {
    ...SESSION_SERVER_STAGING_ENV['benzinga-stock-reports'],
  },
  'benzinga-scanner': {
    ...SESSION_DEV_ENV['benzinga-scanner'],
    equityUrl: 'https://data-api-pro.benzinga.com/rest/v2/scanner/us/equity/scan',
    cryptoUrl: 'https://data-api-pro.benzinga.com/rest/v2/scanner/crypto/scan',
  },
  'benzinga-trending-topics': {
    ...SESSION_DEV_ENV['benzinga-trending-topics'],
    url: 'https://editorial-tools.benzinga.com/api/',
  },
};
